<div class="header ag-ma-md">
  <h2>Browse Search</h2>
  <form class="form-inline" [formGroup]="browseForm" (ngSubmit)="setQueryParams()">
    <div class="row align-items-center">
      <div class="col-sm-12 col-md-6 col-lg-3">
        <input
          agAutofocus
          aria-label="Search Term"
          formControlName="searchTerm"
          type="text"
          class="form-control form-group__input"
          [ngClass]="{
            'border-red':
              !browseForm.controls.searchTerm.valid && browseForm.controls.searchTerm.dirty
          }"
        />
        <!-- Does this need to be a label? -->
        @if (!browseForm.controls.searchTerm.valid && browseForm.controls.searchTerm.dirty) {
          <label class="red" for="searchTerm"> Please Enter a Search </label>
        }
      </div>
      <div class="col-sm-12 col-md-6 col-lg-3">
        <select formControlName="index" class="form-select">
          @for (index of indexes; track index) {
            <option [ngValue]="index.value">{{ index.label }}</option>
          }
        </select>
      </div>
      <div class="col-auto">
        <div class="row align-items-center">
          <label class="col" style="white-space: nowrap" for="page-count">Records Per Page:</label>
          <div class="col">
            <select formControlName="pageSize" id="page-count" class="form-select">
              @for (pageSize of pageSizes; track pageSize) {
                <option [ngValue]="pageSize">
                  {{ pageSize }}
                </option>
              }
            </select>
          </div>
        </div>
      </div>
      <div class="col">
        <button
          class="btn search__button shadow btn-ripple"
          type="submit"
          aria-label="Browse Search"
          [disabled]="!browseForm.valid"
        >
          <i class="fa fa-search"></i>
          Browse Search
        </button>
      </div>
    </div>
  </form>

  @if (isLoading) {
    <mat-spinner diameter="50"></mat-spinner>
  } @else {
    <div style="height: 38px; position: relative" class="ag-mb-sm">
      @if (browseSearchData) {
        <ag-browse-table-paging
          class="paging"
          [initialOffset]="initialSearchOffset"
          [currentOffset]="browseSearchData.currentSetId"
          [previousOffset]="browseSearchData.prevSetId"
          [nextOffset]="browseSearchData.nextSetId"
          (paging)="setQueryParams($event)"
        >
        </ag-browse-table-paging>
      }
    </div>
    @if (browseTerms) {
      <ag-browse-table [browseTerms]="browseTerms"></ag-browse-table>
    }
    <div style="height: 38px; position: relative">
      @if (browseSearchData) {
        <ag-browse-table-paging
          class="bottom-paging"
          [initialOffset]="initialSearchOffset"
          [currentOffset]="browseSearchData.currentSetId"
          [previousOffset]="browseSearchData.prevSetId"
          [nextOffset]="browseSearchData.nextSetId"
          (paging)="setQueryParams($event)"
        >
        </ag-browse-table-paging>
      }
    </div>
  }
</div>
